import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {DatasetAwareComponent} from "../dataset-aware.component";

const DEFAULT_CLS = 'app-checkboxset list-group inline';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-checkboxset',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmCheckboxset]',
  template: `
    <ng-template [ngIf]="!groupby" [ngIfElse]="groupedListTemplate">
      <li *ngFor="let item of datasetItems; let i = index"
          [class.active]="item.selected"
          [ngClass]="['checkbox', 'app-checkbox',itemclass,itemsPerRowClass]">
        <!-- Default item template -->
        <label *ngIf="!content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" [title]="item.label">
          <input [name]="'checkboxset_'+widgetId" type="checkbox" [attr.aria-label]="item.key"
                 [disabled]="disabled || readonly"
                 [attr.aria-checked]="item.selected"
                 [attr.data-attr-index]="i"
                 [value]="item.key" [checked]="item.selected"/>
          <span class="caption" [textContent]="item.label"></span>
        </label>
        <label *ngIf="content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" >
          <input [name]="'checkboxset_'+widgetId" type="checkbox" [attr.aria-label]="item.key"
                 [tabindex]="tabindex" [attr.aria-checked]="item.selected"
                 [disabled]="disabled || readonly" [attr.data-attr-index]="i"
                 [value]="item.key" [tabindex]="tabindex" [checked]="item.selected"/>
          <span class="caption customTemplate" partial-container-target></span>
        </label>
      </li>
    </ng-template>
    <ng-template #groupedListTemplate>
      <li *ngFor="let groupObj of groupedData" class="app-list-item-group">
        <ul class="item-group">
          <li class="list-group-header" [title]="groupObj.key" [ngClass]="{'collapsible-content': collapsible}">
            <h4 class="group-title">{{groupObj.key}}
              <div class="header-action">
                <i class="app-icon wi action wi-chevron-up" *ngIf="collapsible"></i>
                <span *ngIf="showcount" class="label label-default" [textContent]="groupObj.data.length"></span>
              </div>
            </h4>
          </li>
          <li *ngFor="let item of groupObj.data; let i = index;"
              [ngClass]="['checkbox', 'app-checkbox', 'group-list-item', itemclass, itemsPerRowClass]"
              [class.active]="item.selected"
              partialContainer>
            <!-- Default item template -->
            <label *ngIf="!content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" [title]="item.label">
              <input [name]="'checkboxset_' + widgetId" type="checkbox" aria-label="checkbox group"
                     [tabindex]="tabindex"
                     [disabled]="disabled || readonly" [attr.data-attr-index]="i"
                     [value]="item.key" [tabindex]="tabindex" [checked]="item.selected"/>
              <span class="caption" [textContent]="item.label"></span>
            </label>
            <!-- Custom partial template -->
            <label *ngIf="content" class="app-checkboxset-label" [ngClass]="{'disabled':disabled || readonly}" >
              <input [name]="'checkboxset_' + widgetId" type="checkbox" aria-label="checkbox group"
                     [tabindex]="tabindex"
                     [disabled]="disabled || readonly" [attr.data-attr-index]="i"
                     [value]="item.key" [tabindex]="tabindex" [checked]="item.selected"/>
              <span class="caption" partial-container-target></span>
            </label>
          </li>
        </ul>
      </li>
    </ng-template>
  `,
  providers: [
    provideAsWidgetRef(CheckboxsetComponent)
  ],
  exportAs: 'wmCheckboxset',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class CheckboxsetComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-checkboxset');

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

